import { t } from 'i18next'

export const ORDER_TITLE = t('order.title')
export const APPROVE_TITLE = t('order.action.approve')
export const ORDER_ACTIONS = {
  APPROVE: APPROVE_TITLE,
  REVOKE_APPROVE: t('order.action.revokeApprove'),
  CANCEL: t('order.action.cancel'),
  EDIT: t('order.action.edit'),
}

export const APPROVE_STATUS = (value: boolean) =>
  value ? t('order.status.approved') : t('order.status.unapproved')

export const ORDER_SHIPPING_DATE_TITLE = t('order.shipping.shippingDate')
export const ORDER_SHIPPING_INFO_TITLE = t('order.shipping.shippingInfo')
export const ORDER_PAYMENT_INFO_TITLES = {
  subTotal: t('order.item.salonPrice'),
  total: t('order.item.purchasePrice'),
} as const

export const ORDER_SHIPPING_DATE_FIELDS = {
  regularDeliveryDate: t('order.shipping.regularDeliveryDate'),
  desiredDeliveryDate: t('order.shipping.desiredDeliveryDate'),
}

export const ORDER_SHIPPING_INFO_FIELDS = {
  zipCode: t('order.shipping.zipCode'),
  tel: t('order.shipping.tel'),
  deliveryName: t('order.shipping.deliveryName'),
}

export const ORDER_PAYMENT_INFO_FIELDS = {
  thisOrder: t('order.payment.order.current'),
  unshippedOrder: t('order.payment.order.unshipped'),
  totalOrder: t('order.payment.order.totalPrice'),
  untilFreeShippingPrice: t('order.payment.order.untilFreeShippingPrice'),
}
